import {
  type BrandConfig,
  ContactRecipientMode,
  ProductRetirementMode,
} from '@material-bank/mtag-graphql-schema'

// For a brand whose config the browser doesn't have: contact goes to the rep,
// with every contact option on.
export const DEFAULT_BRAND_CONFIG: BrandConfig = {
  contactOptions: {
    call: true,
    leadTime: true,
    other: true,
    pricing: true,
    text: true,
  },
  contactRecipients: {
    email: null,
    mode: ContactRecipientMode.Default,
    phoneNumber: null,
  },
  productRetirement: {
    mode: ProductRetirementMode.Custom,
  },
  redirectUrl: '',
}
